<template>
  <div class="diet-record">
    <div class="record-header">
      <div class="title-wrapper">
        <div class="title-bar" />
        <h3 class="title">饮食记录</h3>
      </div>
      <div class="time-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="['tab-btn', { active: activeTab === tab.value }]"
          @click="handleTabChange(tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>
    </div>

    <div class="record-content">
      <!-- 左侧统计 -->
      <div class="left-stats">
        <div class="warning-icon">
          <img src="@/assets/icon/jikou.png" style="width: 60px;" alt="">
        </div>
        <div class="stat-number">
          <span class="number">{{ totalCount }}</span>
          <span class="unit">次</span>
        </div>
        <div class="stat-label">忌口食材</div>
        <div class="stat-sublabel">食用次数</div>
      </div>

      <!-- 右侧食物列表 -->
      <div class="food-list">
        <div
          v-for="(food, index) in displayList"
          :key="index"
          class="food-item"
        >
          <div class="food-image">
            <img v-if="food.image" :src="food.image" :alt="food.name">
            <img v-else src="@/assets/icon/zanwu.png" alt="">
            <div v-if="food.tags && food.tags.length" class="food-tags">
              <span
                v-for="(tag, idx) in food.tags"
                :key="idx"
                class="food-tag"
                :style="{ backgroundColor: tag.color || '#ff6b6b' }"
              >
                {{ tag.label }}
              </span>
            </div>
          </div>
          <div class="food-count">
            <span class="count">{{ food.count }}</span>
            <span class="count-unit">次</span>
          </div>
          <div class="food-name">{{ food.name }}</div>
        </div>
        <div v-if="displayList.length === 0" class="empty-text">
          暂无记录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DietRecord',
  props: {
    foodList: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: String,
      default: '3' // 改为 '3' 与父组件一致
    },
    totalCount: {
      type: Number,
      default: 0
    },
    normalFoodList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabs: [
        { label: '日', value: '1' }, // 改为 '1'
        { label: '周', value: '2' }, // 改为 '2'
        { label: '月', value: '3' } // 改为 '3'
      ]
    }
  },
  computed: {
    displayList() {
      return this.foodList.length > 0 ? this.foodList : []
    }
  },
  methods: {
    handleTabChange(value) {
      // 直接 emit 数字，不再转换，保持与父组件一致
      this.$emit('tab-change', value)
    }
  }
}
</script>

<style scoped>
.diet-record {
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-bar {
  width: 4px;
  height: 18px;
  background: #333;
  border-radius: 2px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.time-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  padding: 4px 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
}

.tab-btn:hover {
  border-color: #4a7dff;
  color: #4a7dff;
}

.tab-btn.active {
  background: #4a7dff;
  border-color: #4a7dff;
  color: #fff;
}

.record-content {
  display: flex;
  gap: 30px;
}

.left-stats {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  padding-top: 10px;
}

.warning-icon {
  margin-bottom: 12px;
}

.icon-circle {
  width: 60px;
  height: 60px;
  background: #fff5f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ff9f7f;
}

.x-mark {
  font-size: 32px;
  color: #ff6b4a;
  font-weight: 300;
}

.stat-number {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.number {
  font-size: 32px;
  font-weight: 700;
  color: #333;
}

.unit {
  font-size: 14px;
  color: #666;
}

.stat-label {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.stat-sublabel {
  font-size: 12px;
  color: #999;
}

.food-list {
  flex: 1;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.food-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.food-image {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.food-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.food-tags {
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: center;
}

.food-tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  color: #fff;
  font-weight: 500;
}

.food-count {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.count {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.count-unit {
  font-size: 12px;
  color: #666;
}

.food-name {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.empty-text {
  flex: 1;
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 40px 0;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  margin-top: 20px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4a7dff, #6b9fff);
  border-radius: 3px;
  transition: width 0.3s ease;
}
</style>
